export default {
  title: '表示列',
  reset: 'リセット',
  groupLeftFixed: '左に固定された項目',
  groupUnfixed: '固定されてない項目',
  groupRightFixed: '右に固定された項目',
  moveUp: '上へ',
  moveDown: '下へ',
  leftFull: '左側固定列は最大 {max} 列までです',
  rightFull: '右側固定列は最大 {max} 列までです',
  rightLocked: '右側固定列は変更できません',
  saveFailed: '列設定の保存に失敗しました',
  count: '{current}/{max}',
}
